import { Paper } from '@material-ui/core';
import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;

  > p {
    margin-bottom: 0.5rem;
  }
`;

export const WrapperWeeks = styled(Paper)`
  padding: 1.5rem;

  display: grid;
  grid-template-columns: repeat(${({ desktop }) => desktop}, 1fr);
  grid-gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: repeat(${({ tablet }) => tablet}, 1fr);
  }

  @media (max-width: 425px) {
    grid-template-columns: repeat(${({ mobile }) => mobile}, 1fr);
  }
`;

export const Week = styled.div`
  > p {
    display: flex;
    align-items: center;
  }

  > div:nth-child(2) {
    margin-bottom: 2rem;
    margin-top: 0.5rem;
  }
`;
